import React, { useState } from "react";
import CustomButton from "../UIElements/CustomButton";
import { Box, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import InputField from "../UIElements/InputField";
import { yupResolver } from "@hookform/resolvers/yup";
import { emailRegExp } from "../../consts";
import * as yup from "yup";

export default function ChangePasswordModalContent({
    onSucessChangePassWord,
}: {
    onSucessChangePassWord: Function;
}) {
    const [eMail, setEmail] = useState("");
    const validationSchema = yup.object({
        email: yup
            .string()
            .email("Veuillez renseigner une adresse email valide")
            .matches(emailRegExp)
            .required("Veuillez renseigner votre adresse email"),
    });
    const {
        formState: { errors },
        control,
    } = useForm({
        defaultValues: {
            email: "",
        },
        resolver: yupResolver(validationSchema),
    });
    const [disabled, setDisabled] = useState(false);
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "2rem",
                flex: "1 0 0",
            }}
        >
            <Typography
                sx={{
                    alignSelf: "stretch",
                    color: "#005499",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontStyle: "normal",
                    fontWeight: "normal",
                    lineHeight: "normal",
                }}
            >
                Un lien vous serra envoyé a votre adresse mail, si elle est
                connue de notre service. Vous pourrez renseigner un nouveau mot
                de passe depuis ce lien.
            </Typography>
            <Controller
                name={`email`}
                control={control}
                render={({ field: { ref, ...others } }) => (
                    <InputField
                        {...others}
                        label={"Adresse email"}
                        errortext={errors?.email?.message ?? ""}
                        onChange={(e) => setEmail(e.target.value)}
                        value={eMail}
                        outlinedinputsx={{
                            border: "2px solid  #E3E6E8",
                        }}
                    />
                )}
            />
            <CustomButton
                onClick={() => {
                    setDisabled(true);
                    onSucessChangePassWord(eMail);
                }}
                label="Confirmer"
                disabled={disabled}
                customsx={{
                    width: "100%",
                }}
            />
        </Box>
    );
}
